import { LockablePropertyStripLayout } from '../../canvas/properties/LockablePropertyStripLayout';
import { lockAndMoreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { AutoLayoutConfigWidget } from '../autoLayout/AutoLayoutConfigWidget';
import { Zone } from './Zone';
import { ZoneStyleWidget } from './ZoneStyleWidget';

export const zonePropertyLayout = LockablePropertyStripLayout<Zone>((d, s, o, w, a) => [
    //
    // Auto Color
    w.createColorSelector({
        allowNull: true,
        autoSelect: true,
        groups: true,
        value: a.get('autoColor'),
        text: 'Zone Color',
        onSelect() {
            o.update(u => {
                u.rolling(a.keyFor('autoColor'));
                a.set('autoColor', this.value);
            });
        }
    }),

    w.createPopout({
        name: 'style',
        ui: ZoneStyleWidget,
        color: a.get('autoColor'),
        value: {
            border: a.get('border'),
            headingOffset: a.get('headingOffset'),
            headingPosition: a.get('headingPosition'),
            headingStyle: a.get('headingStyle'),
        },
        image: 'deqo://icons/d2/zone',
        text: 'Zone Style',
        onSelect() {
            o.update(u => {
                u.rolling(a.keyFor('border'));
                for (const prop of Object.keys(this.value)) {
                    a.set(prop as any, this.value[prop]);
                }
            });
        },
    }),

    w.createPopout({
        image: 'deqo://icons/d2/flex',
        text: 'Layout Mode',
        ui: AutoLayoutConfigWidget,
        value: a.get('layoutMode'),
        onSelect() {
            o.update(u => {
                u.rolling(a.keyFor('layoutMode'));
                a.set('layoutMode', this.value!);
            });
        }
    }),

    w.createDivide(),

    ...lockAndMoreLayout(d, s, o, w, a),
]);
